import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, CONTACT } from "@/content/site";
import { ThemeToggle } from "@/components/ThemeToggle";
import { ThemeHint } from "@/components/ThemeHint";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md transition-[border-color,box-shadow] duration-300 ${
        scrolled ? "border-b border-[#F0F0F0] shadow-[0_1px_0_rgba(0,0,0,0.02)]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between gap-6">
        <a
          href="/#top"
          data-testid="nav-logo"
          className="font-display text-xl md:text-2xl tracking-tight text-[#252525] whitespace-nowrap"
        >
          Daniel Pekař
        </a>

        <nav aria-label="Hlavní navigace" className="hidden lg:flex items-center gap-5 xl:gap-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href.startsWith("#") ? `/${link.href}` : link.href}
              data-testid={`nav-link-${link.href.replace(/^[#/]+/, "")}`}
              className="text-sm text-[#4A4A4A] hover:text-[#252525] transition-colors duration-300 tracking-wide whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-4">
          <ThemeToggle />
          <ThemeHint />
          <a
            href="/#kontakt"
            data-testid="nav-cta-button"
            className="hidden xl:inline-flex border border-[#B69A58] bg-white text-[#252525] hover:bg-[#B69A58] hover:text-white transition-colors duration-300 px-6 py-3 text-xs uppercase tracking-widest font-medium whitespace-nowrap"
          >
            Domluvit konzultaci
          </a>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-expanded={open}
            aria-label={open ? "Zavřít menu" : "Otevřít menu"}
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-[#252525]"
          >
            {open ? <X className="h-6 w-6" strokeWidth={1.5} /> : <Menu className="h-6 w-6" strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <nav aria-label="Mobilní navigace" className="lg:hidden border-t border-[#F0F0F0] bg-white">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href.startsWith("#") ? `/${link.href}` : link.href}
                data-testid={`nav-mobile-link-${link.href.replace(/^[#/]+/, "")}`}
                onClick={() => setOpen(false)}
                className="text-base text-[#252525] py-1"
              >
                {link.label}
              </a>
            ))}
            <a
              href="/#kontakt"
              data-testid="nav-mobile-cta-button"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center border border-[#B69A58] bg-white text-[#252525] hover:bg-[#B69A58] hover:text-white px-6 py-4 text-xs uppercase tracking-widest font-medium"
            >
              Domluvit konzultaci
            </a>
            <a href={CONTACT.phoneHref} data-testid="nav-mobile-phone" className="text-sm text-[#737373]">
              {CONTACT.phone}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
